export default {
  buttons: {
    cancel: "Annuler",
    dismiss: "Fermer",
    add_waypoint: "Ajouter une destination"
  },
  distance: {
    value: "{distance, number, distance} {unit}"
  },
  send_to_phone: {
    mail: {
      body: "{url}"
    }
  },
  search: {
    title: "Chercher",
    placeholder: "Entrer un lieu",
    enter_location: "Entrer un lieu",
    help: {
      inactive: "Chercher"
    }
  },
  filters: {
    title: "Filtres",
    amenities: {
      title: "Services VL / PL"
    },
    fuels: {
      title: "Carburants disponibles"
    }
  },
  directions: {
    title: "Calcul d'itinéraire",
    placeholder: {
      destination: "Entrer un lieu",
      waypoint: "Entrer un lieu"
    },
    route: {
      title: "Options de route",
      avoid_tolls: "Eviter les péages",
      avoid_highways: "Eviter les autoroutes",
      title_corridor: "Distance jusqu'à la station la plus proche"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# jour} other {# jours}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# min} other {# min}}\
`,
    button: "Chercher"
  },
  locations: {
    title: "Sites",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} De {place}"
  },
  info_window: {
    title: "Détails station",
    services: "Services VL / PL",
    nearby: "A proximité de",
    mobile: {
      telephone: "Tel :"
    },
    opening_hours: {
      title: "Horaires d'ouverture",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      last_updated_on: "Dernière actualisation",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Calcul d'itinéraire"
  },
  fuels: {
    autogas_lpg: "LPG",
    lng: "Shell LNG",
    midgrade_gasoline: "Shell Eurosuper 95 E10",
    premium_diesel: "Shell V-Power Diesel",
    premium_gasoline: "Shell V-Power",
    shell_regular_diesel: "Shell Diesel",
    truck_diesel: "Thermoshell"
  },
  amenities: {
    air_and_water: "Gonflage",
    atm: "Distributeur de billets",
    austrian_highway_sticker: "Vignette d'autoroute - Autriche",
    cafe: "Cafétéria",
    carwash: "Lavage",
    credit_card_american_express: "American Express",
    credit_card_diners_club: "Carte Diners Club",
    credit_card_mastercard: "Mastercard",
    credit_card_visa: "Visa",
    credit_card: "Carte de crédit",
    czech_highway_sticker: "Vignette d'autoroute - Rép. tchèque",
    deli2go: "Café",
    euroshell_card: "Carte euroShell",
    fleet_card_dkv: "Carte DKV",
    fleet_card_eni: "Carte Eni",
    fleet_card_esso: "Carte Esso",
    fleet_card_general: "Carte carburant",
    fleet_card_uta: "Carte UTA",
    food_offerings: "Alimentation",
    full_service: "Personnel de piste",
    guarded_car_park: "Parking sécurisé",
    hgv_lane: "Accessible aux camions",
    high_speed_diesel_pump: "Pompes haut débit",
    hot_food: "Snack Chaud",
    hungarian_highway_sticker: "Vignette d'autoroute - Hongrie",
    parking_lanes: "Parking",
    partner_loyalty_accepted: "Partenaire fidélité accepté",
    pay_at_pump: "Paiement automatique à la pompe",
    self_service: "Libre-service",
    service_bay: "Garage",
    shell_card: "Carte euroShell",
    shop: "Boutique",
    shower: "Douches",
    slovak_highway_sticker: "Vignette d'autoroute - Slovaquie",
    snack_food: "Snack / Fast Food",
    standard_toilet: "Toilettes",
    supermarket_fuel_discount: "Remise sur carburant",
    tim_hortons: "Tim Horton",
    toilet: "Toilettes",
    truck_parking: "Parking PL",
    truckport: "Camions seulement",
    twenty_four_hour: "24 heures",
    twotheloo: "Toilettes",
    vacuum: "Aspirateur",
    vehicle_identity_system: "Système d'identification des véhicules",
    adblue_truck: "AdBlue pour camions à la pompe",
    adblue_car: "AdBlue pour voitures à la pompe",
    adblue_pack: "Conteneur AdBlue dans le shop"
  },
  settings: {
    title: "Réglages",
    tooltip: "Réglages",
    distance_units: {
      km: "kilomètres"
    },
    language: {
      title: "Langue"
    }
  }
}
